import React from "react";
import injectSheet from "react-jss";
import classNames from "classnames";
import PropTypes from "prop-types";

const styles = ({ theme, legacyTheme }) => ({
  root: {
    display: "flex",
    justifyContent: ({ compact }) => (compact ? "start" : "space-between"),
    borderBottom: `1px solid ${theme.colors.tertiary4}`,
    ...legacyTheme.font.primary,
    ...legacyTheme.commonStyles.betterFontRendering,
    fontFamily: theme.fonts.sans
  },
  zebra: {
    padding: [0, 15],
    "&:nth-of-type(odd)": {
      backgroundColor: theme.colors.white
    },
    "&:nth-of-type(even)": {
      backgroundColor: theme.colors.white
    }
  },
  separated: {
    "&:last-child": {
      borderBottom: 0
    }
  },
  balanced: {
    "& dt, & dd": {
      flexBasis: "50%"
    }
  },
  compact: {
    "& dt, & dd": {
      flexBasis: "auto"
    },
    "& dt": {
      paddingRight: 15
    }
  },

  column: {
    display: "block", // Display as rows but force margin collapse on children to achieve correct distance between term and definition
    overflow: "auto"
  }
});

const DescriptionListRow = ({
  children,
  classes,
  zebra,
  separated,
  balanced,
  compact,
  column
}) => {
  const cn = classNames(classes.root, {
    [classes.zebra]: zebra,
    [classes.separated]: separated,
    [classes.balanced]: balanced,
    [classes.compact]: compact,
    [classes.column]: column
  });
  return <div className={cn}>{children}</div>;
};

DescriptionListRow.propTypes = {
  children: PropTypes.node,
  /** Display rows alternating in background color */
  zebra: PropTypes.bool,
  /** Display term and definition as columns */
  column: PropTypes.bool,
  /** Splits the width between the term and definition evenly */
  balanced: PropTypes.bool,
  /** Display term and definition right after eachother */
  compact: PropTypes.bool,
  /** Display a border under each row */
  separated: PropTypes.bool
};

DescriptionListRow.defaultProps = {
  zebra: false,
  column: false,
  balanced: false,
  compact: false,
  separated: false
};

export default injectSheet(styles, { inject: ["classes"] })(DescriptionListRow);
